define(['underscore', 'edge/platform/base/BaseCtrl',
    'edge/platform/flow/FlowFactory',
    '../config/FlowConfig'
], (_, BaseCtrl, flowFactory, flowConfig)=> {

    const fn = function ($scope, $q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService,
                         ViewModelCtx, $stateParams, StateUtils, LocaleService) {
        const countryCode = LocaleService.getCountry().code;

        const ctrl = Object.create(BaseCtrl);
        const quickQuoteVm = ViewModelService.create({
            policyAddress: {country: countryCode},
            productCode: 'PersonalAuto'
        }, 'pc', 'edge.capabilities.quote.streamlined.dto.StreamlinedQuoteDTO');

        const flowDefn = flowConfig($q, wizardFlowService, LoadSaveService, ViewModelService,
            AvailabilityService, TranslateService, ViewModelCtx, $stateParams, StateUtils);
        const flowModelFactory = flowFactory.get($q)(flowDefn);
        const flowModel = flowModelFactory.start(quickQuoteVm);
        const stepNames = ['vehicles', 'address', 'additional', 'quote'];

        ctrl.init = function () {
            $scope.panelsValid = [{}, {}, {}, {}];
            $scope.flow = flowModel;

            $scope.previousTileModel = {};

            $scope.tileModel = {
                viewModel: quickQuoteVm,
                isLocked: false,
                isSkipToQuoting: false,
                startQuoting: undefined,
                get completedSteps() {
                    return flowModel.steps.filter(step => step.name !== 'quote').map(step => step.isCompleted);
                },
                actions: {
                    setLocked: (flag)=> $scope.tileModel.isLocked = flag,
                    setStepCompleted: (stepIdx, status)=> {
                        const step = flowModel.steps[stepIdx];
                        step.isCompleted = status;
                        if (step.isCompleted) {
                            flowModel.next(quickQuoteVm);
                        }
                    },
                    setStarQuotingFn: (startQuoteFn) => {
                        $scope.tileModel.startQuoting = startQuoteFn;
                        flowModel.jumpToStep('quote');
                    },
                    proceedToFullQuote: ()=> {
                        if (flowModel.currentStep.name === 'quote') {
                            flowModel.next(quickQuoteVm);
                        }
                    },
                    reviseQuote: ()=> {
                        flowModel.jumpToStep('vehicles');
                    },
                    triggerSubmission: () => {
                        $scope.form.submitted = true;
                    }
                }
            };

            Object.defineProperty($scope, 'currentStepIndex', {
                get: ()=> flowModel.steps.indexOf(flowModel.currentStep)
            });
        };

        ctrl.getSectionClass = function (stepIdx) {
            if (stepIdx === $scope.currentStepIndex) {
                return 'gw-active-section';
            } else if (stepIdx < $scope.currentStepIdx) {
                return 'gw-inactive-section-left';
            }
            return 'gw-inactive-section-right';
        };

        ctrl.nextPanel = function () {
            if ($scope.currentStepIndex < $scope.flow.steps.length - 1) {
                // Handle if the user tried to transition to quote without valid panels
                if ($scope.currentStepIndex + 1 === $scope.flow.steps.length - 1 && !allInputPanelsValid()) {
                    $scope.form.submitted = true;
                    return;
                }
                flowModel.next(quickQuoteVm).then(()=> {

                    if ($scope.currentStepIndex === flowModel.steps.length - 1) {
                        //set quote tile to quoting for mobile view
                        $scope.tileModel.startQuoting();
                    }

                });
            }
        };

        ctrl.previousPanel = function () {
            if ($scope.currentStepIndex > 0) {
                // If swiping back from quote we must unlock the form
                if ($scope.currentStepIndex === stepNames.indexOf('quote')) {
                    $scope.tileModel.actions.setLocked(false);
                }
                flowModel.previous(quickQuoteVm);
            }
        };

        ctrl.preQuoteFn = function () {
            // Recurse through flow until we get to the quote
            const quoteStateName = stepNames[stepNames.length - 1];
            if (flowModel.currentStep.name !== quoteStateName) {
                _recurseToState(quoteStateName, 'forward');
            }
        };

        ctrl.jumpFn = function (targetStep) {
            const finalStep = stepNames.length - 1;
            // Block jump to quote panel unless all the panels are valid.
            if ((targetStep !== finalStep) || allInputPanelsValid()) {
                const stepName = stepNames[targetStep];
                const currentStateIndex = stepNames.indexOf(flowModel.currentStep.name);
                const direction = targetStep > currentStateIndex ? 'forward' : 'back';

                // Switch to edit mode if going back
                if (currentStateIndex === finalStep && targetStep !== finalStep) {
                    $scope.tileModel.actions.setLocked(false);
                    $scope.transitionQuoteToEdit();
                    //set edit
                } else if (currentStateIndex !== finalStep && targetStep === finalStep) {
                    //Trigger quote if going to that state
                    $scope.tileModel.actions.setLocked(true);
                    $scope.transitionQuoteToQuoted();
                }
                // Recurse through the flow to get to the target step
                _recurseToState(stepName, direction);
            }
        };

        return ctrl.create($scope);

        /**
         * Recurse forward or backward in the flowmodel to get to a step
         * @param stateName - name of the destination step
         * @param direction - the recursion direction - values ('back'|'forward')
         * @private
         */
        function _recurseToState(stateName, direction) {
            // Recurse through flow until we get to the state
            if (flowModel.currentStep.name !== stateName) {
                if (direction === 'back') {
                    flowModel.previous(quickQuoteVm).then(() => {
                        _recurseToState(stateName, direction);
                    });

                } else if (direction === 'forward') {
                    flowModel.next(quickQuoteVm).then(() => {
                        _recurseToState(stateName, direction);
                    });
                }
            }
        }

        function allInputPanelsValid() {
            const inputPanels = $scope.panelsValid.slice(0, -1);
            return _.all(inputPanels, (panelFns) => panelFns.isValid && panelFns.isValid());
        }
    };

    fn.$inject = [
        '$scope',
        '$q',
        'WizardFlowService',
        'qnb.LoadSaveService',
        'ViewModelService',
        'AvailabilityService',
        'TranslateService',
        'qnb.ViewModelCtx',
        '$stateParams',
        'StateUtils',
        'LocaleService'
    ];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/controllers/PAQuickQuoteCtrl.js
 **/